// extracted by mini-css-extract-plugin
module.exports = {"root":"GdprConsent_root__2vAEb"};